import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AuthCard } from "@/components/auth/AuthCard";
import { SigninForm } from "@/components/auth/SigninForm";

export function SigninPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next") ?? "/";
  const { t } = useTranslation("auth");

  return (
    <AuthCard title={t("signin.title")} description={t("signin.description")}>
      <SigninForm onSuccess={() => navigate(next)} />
    </AuthCard>
  );
}
